import React from 'react';
import s from './PremiumFeatureTooltip.module.css';
import Button from '../../../../shared/ui/button/Button';
import IconDiamond from '../../../../shared/ui/icons/IconDiamond';
import Tooltip from '../../../../shared/ui/tooltip/Tooltip';

const PremiumFeatureTooltip = () => {
    return (
        <Tooltip
            content={
                <div className={s.tooltip_pro_container}>
                    <h3 className={s.header}>Premium feature</h3>
                    <p className={s.text}>Subscribe to get 3 day free trial</p>
                    <Button
                        text={'Try Now!'}
                        style={{ background: '#FFDD35', width: '84px', height: 30 }}
                        onClick={() => {}}
                    />
                </div>
            }
        >
            <IconDiamond width={12} />
        </Tooltip>
    );
};

export default PremiumFeatureTooltip;
